import { Modal } from "@mantine/core";
import { FileDto } from '@braoshzmvavz/picnube-common';
import React from "react";
import { HiClock } from "react-icons/hi";
import { formatBytes, formatDate } from "../../utils/Utils";

export default function FileDetail(props: {
  opened: boolean;
  onClose: () => void;
  file: FileDto;
}) {
  if (!props.file) return <></>;

  return (
    <>
      <Modal.Root opened={props.opened} onClose={props.onClose}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>{props.file.name}</Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <div className="flex flex-col gap-2">
              <img
                src={props.file.thumbnailUrl}
                alt={props.file.name}
                className="w-full max-h-[20rem] object-scale-down"
              ></img>
              <div className="flex flex-col justify-between items-start mt-2">
                <table className="w-full">
                  <tbody className="text-sm">
                    <tr>
                      <td>Name</td>
                      <td>{props.file.name}</td>
                    </tr>
                    <tr>
                      <td>Size</td>
                      <td>{formatBytes(props.file.size)}</td>
                    </tr>
                    <tr>
                      <td>Width</td>
                      <td>{props.file.width}</td>
                    </tr>
                    <tr>
                      <td>Height</td>
                      <td>{props.file.height}</td>
                    </tr>
                    <tr>
                      <td>EXIF Creation Date</td>
                      <td>
                        {formatDate(props.file.exifCreationDate)}
                      </td>
                    </tr>
                    <tr>
                      <td>File Creation Date</td>
                      <td>
                        {formatDate(props.file.dateCreated)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
}
